import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LedgerBalance, LedgerBalanceCreate, LedgerBalanceFilter } from '../data/ledgerBalance';

export function createLedgerBalanceService(client: AxiosInstance) {
  return createCrudService<LedgerBalance, LedgerBalanceCreate, LedgerBalanceFilter>(
    client,
    '/accounting/LedgerBalance',
    'id',
  );
}

export type LedgerBalanceService = CrudService<LedgerBalance, LedgerBalanceCreate, LedgerBalanceFilter>;
